import React, { Component, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { io } from "socket.io-client";
import ClipLoader from "react-spinners/ClipLoader";
import LoginService from "../../services/login";
import MatchService from "../../services/match";
import userDetail from "../../services/user";
import routes from "../../routes";
import Sidebar from "../../Pages/Home/Sidebar";

const DefaultFooter = React.lazy(() => import("./DefaultFooter"));
const DefaultHeader = React.lazy(() => import("./DefaultHeader"));
const DefaultsideNav = React.lazy(() => import("./DefaultsideNav"));
class DefaultLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      notifications: null,
      settings: [],
      liveMsgList: null,
      banners: [],
      maintenanceStatus: 0,
      refreshReCaptcha: false,
      token: "",
      isCaptchaVerified: false,
      isLight: localStorage.getItem("light") === "true",
      cricketMatches: "",
      soccerMatches: "",
      tennisMatches: "",
    };
  }

  loading = () => (
    <div className="col-md-12">
      <div className="type-loader">
        <ClipLoader color="#ffb80a" />
      </div>
    </div>
  );
  setTokenFunc = (getToken) => {
    this.setState({
      token: getToken,
      isCaptchaVerified: true,
    });
  };

  signOut = () => {
    this.clientInfo = null;
    window.location.reload(true);
  };

  logoutHandler = (e) => {
    LoginService.userLogoutStatus()
      .then((res) => {
        if (res.data.data.LogedIn === 0) {
          localStorage.clear();
          window.location.reload(true);
        }
      })
      .catch((err) => console.log(err.message));
  };

  loginHandler = (initial) => {
    this.clientInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    this.token = JSON.parse(localStorage.getItem("@access:token"));
    this.clientName =
      this.clientInfo && this.clientInfo.user
        ? this.clientInfo.user.ClientName
        : "";
    if (this.clientInfo !== null) {
      this.setState({ user: this.clientInfo.user });
      userDetail.userDetail().then((response) => {
        let checkpath =
          this.props.history &&
          this.props.history.location &&
          this.props.history.location.pathname;
        if (initial || checkpath != "/") {
          this.setState({ user: response.data.data });
        }
        // else{
        let userins = response.data.data;
        let totalExposure = 0;
        let balancemount = 0;
        userins &&
          userins.GamewiseExposure &&
          userins.GamewiseExposure.forEach((expo) => {
            totalExposure += expo.UsedExposure;
          });
        if (userins && userins.BalanceAmount) {
          balancemount = userins.BalanceAmount;
          // if (totalExposure && totalExposure > 1) {
          //   balancemount = balancemount - totalExposure;
          // }
        }
        // console.log('settingitem totalExposure',totalExposure)
        // console.log('settingitem balancemount',balancemount)
        localStorage.setItem("totalExposure", totalExposure);
        localStorage.setItem("balancemount", balancemount);
        if (userins.BonusAmount) {
          localStorage.setItem("bonusamount", userins.BonusAmount);
        }
        if (response.data.message == "tokenChanged") {
          let deviceid = localStorage.getItem("deviceID");
          if (
            localStorage.getItem("loginUserInfo") &&
            JSON.parse(localStorage.getItem("loginUserInfo")).user &&
            JSON.parse(localStorage.getItem("loginUserInfo")).user
              .ClientName !== "demox92"
          ) {
            if (deviceid && userins.deviceID && deviceid !== userins.deviceID) {
              this.logoutHandler();
              // console.log('Users Logout')
            }
            // this.logoutHandler();
            // console.log('user logout.')
          }
        }
        // }
      });
    } else {
      this.setState({ user: null });
      clearInterval(this.intervalId);
      let path = this.props.history.location.pathname;
      // console.log('path',path)
      // return;

      if (
        path &&
        ![
          "/inplay",
          "/about-us",
          "/getting-started",
          "/faq",
          "/help",
          "/terms-conditions",
          "/online-cricket-betting",
          "/Sports/CRCKT",
          "/Sports/Soccer",
          "/Sports/TNNS",
          "/join-now",
          "/login",
          "/join-here",
          "/online-ipl-betting",
          "/privacy-policy",
          "/faq",
          "/terms-conditions",
          "/MasterID",
          "/forgotPassword",
        ].includes(path)
      ) {
        this.props.history.push("/");
      }
    }
  };
  componentDidMount = async () => {
    localStorage.getItem("light");
    let loc = this.props.history.location;
    if (loc && loc.hash && loc.hash == "#/online-cricket-betting") {
      this.props.history.push("/online-cricket-betting");
    } else if (loc && loc.hash && loc.hash == "#/online-ipl-betting") {
      this.props.history.push("/online-ipl-betting");
    }
    userDetail.webSettings({portalName: 'Batman247'}).then((response) => {
      if (response && response.status == 200) {
        this.setState({
          settings: response?.data?.data?.settings,
        });
        this.setState({
          liveMsgList: response?.data?.data?.liveMsgList,
        });
        this.setState({
          banners: response?.data?.data?.banners,
        });
      }
    });
    this.loginHandler(true);
    this.intervalId = setInterval(() => {
      this.clientInfoBet = JSON.parse(localStorage.getItem("bet"));
      this.withdrawlInfo = JSON.parse(localStorage.getItem("withdrawlsuccess"));
      if (this.clientInfoBet !== undefined && this.clientInfoBet === true) {
        localStorage.removeItem("bet");
      }
      if (this.withdrawlInfo !== undefined && this.withdrawlInfo === true) {
        localStorage.removeItem("withdrawlsuccess");
      }
    }, 3000);
    await this.connectSocket();
    const handleVisibilityChange = async () => {
      if (document.visibilityState === "visible") {
        await this.connectSocket();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    this.sportsList();
    // const intervalId = setInterval(() => {
    //   this.sportsList();
    // }, 30000);
    // return () => {
    //   clearInterval(intervalId);
    // };
  };

  sportsList = () => {
    MatchService.gameListByGameType("CRCKT")
      .then(({ data }) => {
        this.setState({
          cricketMatches: data,
        });
      })
      .catch((err) => {
        console.log(err.message);
      });
    MatchService.gameListByGameType("Soccer")
      .then(({ data }) => {
        this.setState({
          soccerMatches: data,
        });
      })
      .catch((err) => {
        console.log(err.message);
      });
    MatchService.gameListByGameType("TNNS")
      .then(({ data }) => {
        this.setState({
          tennisMatches: data,
        });
      })
      .catch((err) => {
        console.log(err.message);
      });
  };
  // socket connection for user data
  connectSocket = () => {
    // connecting socket
    if (localStorage.getItem("loginUserInfo")) {
      let wssURL = "";
      const token = JSON.parse(localStorage.getItem("@access:token"));
      process.env.NODE_ENV === "development"
        ? 
          (wssURL = "https://api-out.sportsx9.com:8443")
        : 
          (wssURL = "https://api-out.sportsx9.com:8443");

      const socket = io(wssURL, {
        transports: ["websocket"],
        auth: {
          token: token,
        },
      });

      socket.on(
        "connect",
        function () {
          // console.log('User WebSocket connected');
          this.loginHandler(true);
        }.bind(this)
      );

      socket.on("error", (error) => {
        console.log("WebSocket error:", error);
      });

      socket.on(
        "sendUserResponse",
        function (userdata) {
          // console.log('send userdata');
          const clientInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
          const user_id =
            clientInfo && clientInfo.user ? clientInfo.user._id : "";
          if (user_id == userdata._id) {
            this.setState({ user: userdata });
            let userins = userdata;
            let totalExposure = 0;
            let balancemount = 0;
            userins &&
              userins.GamewiseExposure &&
              userins.GamewiseExposure.forEach((expo) => {
                totalExposure += expo.UsedExposure;
              });
            if (userins && userins.BalanceAmount) {
              balancemount = userins.BalanceAmount;
              // if (totalExposure && totalExposure > 1) {
              //   balancemount = balancemount - totalExposure;
              // }
            }
            localStorage.setItem("totalExposure", totalExposure);
            localStorage.setItem("balancemount", balancemount);
            if (userins.BonusAmount) {
              localStorage.setItem("bonusamount", userins.BonusAmount);
            }
            if (userins.tokenchange == "true" || userins.tokenchange == true) {
              if (
                localStorage.getItem("loginUserInfo") &&
                JSON.parse(localStorage.getItem("loginUserInfo")).user &&
                JSON.parse(localStorage.getItem("loginUserInfo")).user
                  .ClientName !== "demox92"
              ) {
                this.logoutHandler();
                // console.log('UserLogout.')
              }
            }
          }
          // gameDetail(rate && rate[0]._id);
        }.bind(this)
      );

      socket.emit("userEndRoom", {
        userName: this?.clientInfo?.user?.ClientName,
      });

      socket.on(
        "RecieveUserResponse",
        function (userdata) {
          // console.log('recieve userdata');
          const clientInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
          const user_id =
            clientInfo && clientInfo.user ? clientInfo.user._id : "";
          if (user_id == userdata._id) {
            this.setState({ user: userdata });
            let userins = userdata;
            let totalExposure = 0;
            let balancemount = 0;
            userins &&
              userins.GamewiseExposure &&
              userins.GamewiseExposure.forEach((expo) => {
                totalExposure += expo.UsedExposure;
              });
            if (userins && userins.BalanceAmount) {
              balancemount = userins.BalanceAmount;
              // if (totalExposure && totalExposure > 1) {
              //   balancemount = balancemount - totalExposure;
              // }
            }
            localStorage.setItem("totalExposure", totalExposure);
            localStorage.setItem("balancemount", balancemount);
            if (userins.BonusAmount) {
              localStorage.setItem("bonusamount", userins.BonusAmount);
            }
            if (userins.tokenchange == "true" || userins.tokenchange == true) {
              let deviceid = localStorage.getItem("deviceID");
              if (
                localStorage.getItem("loginUserInfo") &&
                JSON.parse(localStorage.getItem("loginUserInfo")).user &&
                JSON.parse(localStorage.getItem("loginUserInfo")).user
                  .ClientName !== "demox92"
              ) {
                if (
                  deviceid &&
                  userins.deviceID &&
                  deviceid !== userins.deviceID
                ) {
                  this.logoutHandler();
                  // console.log('Users Logout')
                }
              }
            }
          }
          // gameDetail(rate && rate[0]._id);
        }.bind(this)
      );

      return () => {
        socket.disconnect();
      };
    }
    // connecting socket
  };

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  userLogoutStatusCheck = () => {
    userDetail
      .userLogoutStatus()
      .then((response) => {
        localStorage.clear();
        // console.log('User Logout')
        window.location.reload();
      })
      .catch((err) => console.log(err.message));
  };

  toggleLight = () => {
    const newLightState = !this.state.isLight;
    this.setState({ isLight: newLightState });
    localStorage.setItem("light", newLightState);
  };

  render() {
    const currentUrl = window.location.href;
    const urlParams = new URLSearchParams(currentUrl.split("?")[1]);
    const savedRefferCode = urlParams.get("reffer");

    if (savedRefferCode) {
      localStorage.setItem("savedRefferCode", savedRefferCode);
      if (currentUrl.includes("/join-now")) {
        this.props.history.replace("/join-now");
      }
    }
    const { isLight } = this.state;
    let is_casino = false;
    let is_home = false;
    let is_sports = false;
    let is_landing = false;
    let is_score = false;
    let is_ipl_betting = false;
    let is_cricket_betting = false;
    let is_Login_Signup = false;
    let showSidebar = true;
    if (this.props.history.location) {
      let path = this.props.history.location.pathname;
      let clientInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
      if (
        clientInfo != null &&
        clientInfo.user.PasswordChanged == 0 &&
        path != "/ChangePassword"
      ) {
        this.props.history.push("/ChangePassword");
      }
      if (path == "/") {
        is_home = true;
      } else if (path.includes("/Sports/")) {
        is_sports = true;
      } else if (path.includes("/score/")) {
        is_score = true;
      } else if (path.includes("/online-ipl-betting")) {
        is_ipl_betting = true;
      } else if (path.includes("/online-cricket-betting")) {
        is_cricket_betting = true;
      } else if (
        [
          "/login",
          "/login/",
          "login",
          "/join-now",
          "/join-now/",
          "join-now",
          "/join-here",
          "/join-here/",
        ].includes(path)
      ) {
        is_Login_Signup = true;
      }

      if (
        [
          "/login",
          "/login/",
          "login",
          "/join-now",
          "/join-now/",
          "join-now",
          "/wallet",
          "/Profile",
          "/myMarkets",
          "/bonusStatement",
          "/profile",
          "/stackSetting",
          "/join-here"
        ].includes(path)
      ) {
        showSidebar = false;
      } else if (
        path.includes("/Deposit/") ||
        path.includes("/Withdrawl") ||
        path.includes("/accountStatement")
      ) {
        showSidebar = false;
      }

      is_casino = path
        ? path.includes("CasinoDetail") ||
          path.includes("Casino") ||
          path.includes("LiveCasinos") ||
          path.includes("sports-book") ||
          path.includes("virtual-sports")
        : false;
    }

    const { user, isCaptchaVerified, cricketMatches, soccerMatches, tennisMatches } = this.state;

    return (
      <React.Fragment>
        <div className="ie-panel">
          <a href="https://windows.microsoft.com/en-US/internet-explorer/">
            <img
              src="./images/warning_bar_0000_us.jpg"
              height="42"
              width="820"
              alt="You are using an outdated browser. For a faster, safer browsing experience, upgrade for free today."
            />
          </a>
        </div>
        {this.state.maintenanceStatus === 0 ? (
          <>
            {/* <GoogleReCaptchaProvider
              reCaptchaKey={`6LcKWO8pAAAAAOBu2U5p9RPLoSuFE_SsiePI0G9I`}
            >
              <GoogleReCaptcha
                className="google-recaptcha-custom-class"
                onVerify={this.setTokenFunc}
                refreshReCaptcha={this.state.refreshReCaptcha}
              /> */}
            {
              // isCaptchaVerified
              //   ?
              <div
                className={`${isLight ? "light" : ""} container-fluid p-0 ${
                  is_casino == true ? "casino-set" : ""
                }${is_Login_Signup ? "login-section" : ""}`}
              >
                <ToastContainer />
                <Suspense fallback={this.loading()}>
                  {/* <button className='mt-6' onClick={this.toggleLight} style={{position:"fixed",zIndex:9}}>on/off</button> */}
                  <DefaultHeader
                    casinopage={is_casino}
                    has_landing={is_landing}
                    onLogout={this.signOut}
                    onLogIn={this.loginHandler}
                    user={user}
                    settings={this.state.settings}
                    liveMsgList={this.state.liveMsgList}
                    cricketMatches={cricketMatches && cricketMatches}
                    soccerMatches={soccerMatches && soccerMatches}
                    tennisMatches={tennisMatches && tennisMatches}
                  />
                  <section className="main-section">
                    <div className={`row m-0`}>
                      {showSidebar && (
                        <div className="col-sm-3 col-md-3 col-lg-3 p-0 sidebar-menu">
                          <Sidebar
                            {...this.props}
                            settings={this.state.settings}
                            showPromotion={true}
                            cricketMatches={cricketMatches && cricketMatches}
                            soccerMatches={soccerMatches && soccerMatches}
                            tennisMatches={tennisMatches && tennisMatches}
                          />
                        </div>
                      )}

                      <div
                        className={`main-content ${
                          showSidebar
                            ? "col-sm-12 col-md-9 col-lg-9"
                            : "col-sm-12 col-md-12 col-lg-12"
                        }`}
                      >
                        {/* <div className="inner-container"> */}
                        <Suspense fallback={this.loading()}>
                          <Switch>
                            {routes.map((route, idx) => {
                              return route.component ? (
                                <Route
                                  key={idx}
                                  path={route.path}
                                  exact={route.exact}
                                  name={route.name}
                                  render={(props) => (
                                    <route.component
                                      {...props}
                                      user={user}
                                      banners={this.state.banners}
                                      cricketMatches={
                                        cricketMatches && cricketMatches
                                      }
                                      soccerMatches={
                                        soccerMatches && soccerMatches
                                      }
                                      tennisMatches={
                                        tennisMatches && tennisMatches
                                      }
                                    />
                                  )}
                                />
                              ) : null;
                            })}
                            <Redirect from="/" to="/" />
                          </Switch>
                        </Suspense>
                        {/* </div> */}
                        {this.state.settings &&
                        this.state.settings.length > 0 ? (
                          <DefaultFooter
                            casinopage={is_casino}
                            footershow={
                              is_home ||
                              is_sports ||
                              is_ipl_betting ||
                              is_cricket_betting
                            }
                            settings={this.state.settings}
                            user={user}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </section>
                </Suspense>
                {/* </div> */}
                {/* <div className={`${is_landing ? "landingfooter" : ""} ${is_score ? 'scorepage' : ''} ${is_casino == true ? 'caison-land' : ''}`}>
                      <Suspense fallback={this.loading()}>
                      </Suspense>
                    </div> */}
              </div>
              // :
              // this.loading()
            }
            {/* </GoogleReCaptchaProvider> */}
          </>
        ) : (
          <>
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
              }}
            >
              <h3>Sorry, We Are Down For Maintenance</h3>
            </div>
          </>
        )}
      </React.Fragment>
    );
  }
}

export default DefaultLayout;
